module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1015-cc488a611e35fdde7888cefccdb821ba.png";